import { useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext'

export const useSkin = () => {
  const {
    theme: skin,
    setTheme: setSkin,
    setNotPersistTheme
  } = useContext(ThemeContext)

  return [skin, setSkin, setNotPersistTheme]
}
